import { c } from "../classroomColors";
import { STANDE } from "../standeTokens";

/** The three phases of a session, in the order a class runs. */
export const PHASES = [
  {
    key: "pre",
    label: "Pre-class",
    blurb: "What students want covered before the class.",
  },
  {
    key: "in",
    label: "In-class",
    blurb: "What you run during the class.",
  },
  {
    key: "post",
    label: "Post-class",
    blurb: "The work set after the class.",
  },
];

const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
const DAYS = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

export const formatWhen = (value) => {
  if (!value) return null;
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return null;
  let h = d.getHours();
  const ampm = h >= 12 ? "PM" : "AM";
  h = h % 12 || 12;
  return `${DAYS[d.getDay()]} ${d.getDate()} ${MONTHS[d.getMonth()]}, ${h}:${String(d.getMinutes()).padStart(2, "0")} ${ampm}`;
};

export const formatDay = (value) => {
  if (!value) return null;
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return null;
  return `${d.getDate()} ${MONTHS[d.getMonth()]} ${d.getFullYear()}`;
};

/**
 * Where a session sits relative to now. Scheduling is optional, so an
 * unscheduled session is its own state rather than being forced into one.
 */
export const sessionStage = (session) => {
  if (!session?.scheduled_at) return "unscheduled";
  const when = new Date(session.scheduled_at);
  if (Number.isNaN(when.getTime())) return "unscheduled";
  const now = new Date();
  if (when > now) return "upcoming";
  // A class is "today" for the rest of the calendar day it was held.
  const endOfDay = new Date(when);
  endOfDay.setHours(23, 59, 59, 999);
  return now <= endOfDay ? "today" : "past";
};

export const STAGES = {
  today: { label: "Today", dot: STANDE.secondaryOrange },
  upcoming: { label: "Upcoming", dot: STANDE.primaryBlue },
  past: { label: "Held", dot: "#2fa360" },
  unscheduled: { label: "Not scheduled", dot: "#9a9a9a" },
};

/** The datetime-local input wants "YYYY-MM-DDTHH:mm" in local time. */
export const toLocalInput = (value) => {
  if (!value) return "";
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return "";
  const pad = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
};

export const inputStyle = {
  height: "38px",
  borderRadius: "9px",
  bg: c.inputBg,
  border: "1px solid",
  borderColor: c.inputBorder,
  color: c.text,
  fontSize: "13px",
  _placeholder: { color: c.textMuted },
  _focus: { borderColor: c.textMuted, boxShadow: "none" },
};
